// Contact page scaffold (contact details + form entry point).
import PageHero from "../components/layout/PageHero";
import ContactInfo from "../components/sections/contact/ContactInfo";
import ContactForm from "../components/sections/contact/ContactForm";
import { useLanguage } from "../i18n/LanguageContext";


export default function ContactPage() {
  const { t } = useLanguage();
  return (
    <main className="contact-page">
      <PageHero
        title={t.contact.heroTitle}
        subtitle={t.contact.heroText}
        showSlider={false}
        showImage={false}
      />

      <div className="container">
        <section className="contact-grid">
          <ContactForm />
          <ContactInfo />
          
        </section>
      </div>
    </main>
  );
}

